import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import SponsorView from './View';
import sponsorsBlockSchema from './schema';
import { useSelector } from 'react-redux';

export const SponsorEdit = (props) => {
  const {
    metadata,
    content,
    block,
    blocksErrors,
    onChangeBlock,
    data,
    blocksConfig,
    selected,
    intl,
  } = props;
  const sponsors = useSelector((store) => store.sponsors.sponsors);
  const contentObject = metadata || content || {};
  let schema = sponsorsBlockSchema({ data, intl });
  schema.properties.items.choices = sponsors?.sponsors?.map(({ id, title }) => [
    id,
    title,
  ]);
  if (!data?.managed) {
    data.items =
      contentObject.sponsors?.map((sp) => {
        return typeof sp === 'string' ? sp : sp.token;
      }) || [];
    schema.properties.items.isDisabled = true;
  }

  React.useEffect(() => {
    if (!data?.managed) {
      data.items =
        contentObject.sponsors?.map((sp) => {
          return typeof sp === 'string' ? sp : sp.token;
        }) || [];
    }
  }, [contentObject.sponsors]);

  return (
    <>
      <SponsorView {...props} path={getBaseUrl(props.pathname)} mode="edit" />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          onChangeField={(id, value) => {
            if (id === 'managed' && value === true) {
              // Clear items if switching to managed
              onChangeBlock(block, {
                ...data,
                managed: value,
                items: [],
              });
              return;
            }
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          errors={blocksErrors}
          blocksConfig={blocksConfig}
          block={block}
          // navRoot={navRoot}
          // contentType={contentType}
        />
      </SidebarPortal>
    </>
  );
};

export default SponsorEdit;
